import { render, staticRenderFns } from "./InquiryProcess.vue?vue&type=template&id=12ff2dcb&"
import script from "./InquiryProcess.vue?vue&type=script&lang=js&"
export * from "./InquiryProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports